import { atom } from "recoil";

export const promotionConfigModalStore = atom({
	key: "promotionConfigModalStore",
	default: {
		show: false,
		loaded: false,
		crypto: 0,
		fiat: 0,
	},
});
